export const GET_PARAMS = {
    popup: "popup",
    memberCode: "memberCode",
};

export const GET_POPUPS = {
    popup: {
        profile: "profile",
        chat: "chat",
        advancedSearch: "advancedSearch",
        bounakirMessage: "bounakirMessage",
        findYourAccount: "findYourAccount",
        premiumMessage: "premiumMessage",
        premiumOptions: "premiumOptions",
        premiumPlanDetails: "premiumPlanDetails",
    },
};